import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@material-ui/core";
import { connect } from "react-redux";

import APP_CONSTANTS from "../../constants";
import MakeAPICall from "../../apiCalls/common";
import { getFormattedMonthDate } from "../../utils/dateTimeHelper";

import { searchPatientsApiRoute } from "../../apiRoutes";

const SearchPR = props => {
  const wrapperRef = useRef(null);
  let patInputInterval = useRef();

  const [apiCallParams, setApiCallParams] = useState(null);
  const [patientOpen, setPatOpen] = useState(false);
  const [patient, setPatient] = useState(null);
  const [patientList, setPaitentList] = useState([]);
  const [loading, setLoading] = useState(false);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setPatient(null);
          setPatOpen(false);
          setPaitentList([]);
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideAlerter(wrapperRef);

  const setPatientInputVal = val => {
    clearTimeout(patInputInterval.current);

    setPatient({ id: "", name: val });

    if (val.length > 0) {
      patInputInterval.current = setTimeout(() => {
        if (patient !== null) {
          setPatOpen(true);
          setLoading(true);

          setApiCallParams({
            reqType: "GET",
            reqUrl: searchPatientsApiRoute,
            params: { searchParam: val },
            successCallback: res => {
              setLoading(false);
              setPaitentList(res.data.data.patients);
              // if (res.data.data.patients.length === 0) {
              //   setPatOpen(false);
              // }
            },
            failureCallback: err => {
              setLoading(false);
              setPatOpen(false);
            }
          });
        }
      }, 1000);
    } else {
      setPatOpen(false);
    }
  };

  const setSelectedPatient = pat => {
    const auth = props.auth.user;
    window.open(
      APP_CONSTANTS.pmsURL +
        "/patient/patientDetails?accessToken=" +
        auth.accessToken +
        "&patientId=" +
        pat.id +
        "&searchType=" +
        auth.userType +
        "&adminName=" +
        auth.firstName +
        " " +
        auth.lastName,
      "_blank"
    );

    setPatient(null);
    setPatOpen(false);
    setPaitentList([]);
  };

  return (
    <div
      ref={wrapperRef}
      className="search-pr-box-container input-group position-relative"
    >
      <div className="input-group-prepend">
        <span className="input-group-text search-icon">
          <i className="fas fa-search"></i>
        </span>
      </div>
      <input
        type="text"
        className="form-control search-pr-input"
        placeholder="Search Patient Records"
        value={patient !== null ? patient.name : ""}
        onChange={e => {
          setPatientInputVal(e.target.value);
        }}
      />
      {patientOpen === true && (
        <div className="custom-dropdown-search-list custom-dropdown-search-list-v2">
          {loading && (
            <div className="list-loader">
              <CircularProgress disableShrink className="primary-loader" />
            </div>
          )}
          {!loading && patientList && patientList.length > 0 && (
            <ul>
              {patientList.map((item, index) => {
                let dob = getFormattedMonthDate(item.dateOfBirth);
                let patName = "";

                patName = patName + item.firstName;

                if (item.middleName && item.middleName.trim().length > 0) {
                  patName = patName + " " + item.middleName;
                }

                if (item.lastName && item.lastName.trim().length > 0) {
                  patName = patName + " " + item.lastName;
                }
                return (
                  <li
                    onClick={e =>
                      setSelectedPatient({
                        id: item._id,
                        name: patName
                      })
                    }
                    key={index}
                  >
                    <div className="item-container">
                      <p className="name">{patName}</p>
                      <p>
                        {item.gender}&nbsp;&nbsp;&nbsp;DOB:&nbsp;
                        {dob}
                        &nbsp;&nbsp;&nbsp;UIN:&nbsp;{item.patientId}
                      </p>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
          {!loading && patientList && patientList.length === 0 && (
            <ul>
              <li>
                <div className="item-container">
                  <p className="name">No Data Found</p>
                </div>
              </li>
            </ul>
          )}
        </div>
      )}
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(SearchPR);
